import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'


class Hero extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;
            margin-top: 50px;            
        `        

        const Heading2 = styled.h2`
            font-size: 40px;
            color: #fff;
            font-weight: 700;
            text-transform: uppercase;
            background: -webkit-linear-gradient(left, #c1eb18 , #65ff00);
            background: -o-linear-gradient(right, #c1eb18, #65ff00);
            background: -moz-linear-gradient(right, #c1eb18, #65ff00);
            background: linear-gradient(to right, #c1eb18, #65ff00); 
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
            @media (max-width:767px) {
                font-size: 40px;
                line-height: 40px;
            }
           @media (min-width:768px) and (max-width:1500px) {
                font-size: 70px;
            }
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #C1EB18;
            margin-bottom: 30px;
            @media (min-width:768px) {
                margin-left: 6px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
            }
        `

        const BottomContent = styled.div`
            position: relative;
            width: 100%;
            padding-bottom: 100px;            
            @media (min-width:1025px) and (max-width: 1400px) {    
                bottom: -35%;
            }
            @media (max-width:767px) {
                position: relative;
                bottom: 0;
            } 
            @media (min-width:768px) and (max-width: 1023px) {    
                bottom: -25%;
            }
        `

        const ServiceCol = styled(Col)`
            padding: 0;
            border-right: #444;
            &.no-border {
                border-right: none;
            }
            @media (max-width:500px) {
                border-right:none;
            }
        `

        const Service = styled.div`
            min-height: 300px;
            background-color: #111;
            transition: .2s;
            display: flex;
            justify-content: center;
            flex-direction: column;
            &:hover {
                background-color: #222;
            }
        `
        const ServiceContent = styled.div`
            padding: 40px;
            color: #fff;
        `
        const ServiceHeading = styled.h3`
            font-size: 25px;
            font-weight: 400;
            font-family: Antonio,sans-serif;
        `
        
        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 10px;
        `

        const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `

        const ServiceText = styled.p`
            font-size: 14px;
            font-weight: 300;
            color: #c5c5c5;
        `        

        const Content = styled.div`
            position: relative;
            z-index: 10
        `

        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #c5c5c5;
            padding-bottom: 30px;
        `

        const AboutContainer = styled(Container)`
            padding: 50px 0;
            @media (max-width: 500px) {
                padding: 50px 20px;
            }
        `

        const Heading = styled.h2`
            font-size: 60px;
            font-family: Poppins;
            color: #fff;
            line-height: 60px;
            text-align: center;
            padding-bottom: 80px;        
        `        
        
        return (
            <Section>
                <Container>
                    <Content>

                        <Heading2>
                            La Magia del RAID 10
                        </Heading2>
                        <Separator />
                    </Content>
                </Container>
                <BottomContent>
                    <Container>
                        <Row>
                            <ServiceCol md={6} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image1} alt="VPS en RAID 10" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            ¿Qué es RAID 10?
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            RAID 10 combina la velocidad del RAID 0 con la redundancia del RAID 1. En términos sencillos,
                                            proporciona velocidad y seguridad simultáneamente. Cada acción realizada en tu VPS se beneficia de esta combinación única.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={6}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image2} alt="VPS Colombia" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Velocidad y Rendimiento Inigualables
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Imagina tu VPS ejecutándose a una velocidad óptima, incluso en momentos de carga intensiva.
                                            RAID 10 divide y replica tus datos, asegurando que todas las operaciones sean rápidas y eficientes.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                        </Row>
                    </Container>
                </BottomContent>

                <AboutContainer>
                    <Row>
                        <Col md={12}>                            
                                <Heading>Garantía de reembolso por 30 días</Heading>
                                <Text>
                                    Garantizamos tu satisfacción. Si en los primeros 30 días no estás completamente satisfecho,
                                    te reembolsamos sin preguntas. Tu confianza es nuestra prioridad.</Text>
                        </Col>
                    </Row>
                </AboutContainer>
            </Section>
            
        )
    }
}

const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {          
          image1: file(relativePath: { eq: "icons/raid-10.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image2: file(relativePath: { eq: "icons/litespeed.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }          
        }
      `}
        render={(data) => {            
            const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
            const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);            
            return <Hero data={data} image1={image1} image2={image2}{...props} />;
        }}
    />
);

export default Iconos;
